module.exports = __webpack_public_path__ + "img/Windy.b3dc3b8b.svg";